import {createContext} from "react";

export const PopUpContext = createContext({})
